import { Link } from 'react-router-dom';
import {
  Wheat, Droplets, Milk, CookingPot, Cross, HeartPulse,
  Baby, Egg, Coffee, Carrot,
} from 'lucide-react';

/**
 * Fixed "Daily Essentials" bar — the Needs-First anchor of BharatCart.
 *
 * Horizontally scrollable on small phones; grid on desktop. Text-heavy,
 * high-contrast, no images — designed to load fast on 2G/3G.
 * Rendered at the top of every page inside `Layout`.
 */
const ESSENTIALS = [
  { key: 'milk',       label: 'Milk',        q: 'milk',              Icon: Milk,        bg: '#E3F2FD', fg: '#0D47A1' },
  { key: 'grains',     label: 'Grains',      q: 'rice atta',         Icon: Wheat,       bg: '#FFF8E1', fg: '#8D6E00' },
  { key: 'oil',        label: 'Cooking Oil', q: 'cooking oil',       Icon: Droplets,    bg: '#FFF3E0', fg: '#8D3A0A' },
  { key: 'dal',        label: 'Dal & Pulses',q: 'dal',               Icon: CookingPot,  bg: '#FFF8E1', fg: '#5D4037' },
  { key: 'veg',        label: 'Vegetables',  q: 'vegetable',         Icon: Carrot,      bg: '#E8F5E9', fg: '#1B5E20' },
  { key: 'eggs',       label: 'Eggs & Bread',q: 'egg bread',         Icon: Egg,         bg: '#FFF8E1', fg: '#8D6E00' },
  { key: 'tea',        label: 'Tea & Sugar', q: 'tea sugar',         Icon: Coffee,      bg: '#EFEBE9', fg: '#4E342E' },
  { key: 'otc',        label: 'OTC Medicine',q: 'paracetamol',       Icon: Cross,       bg: '#FFEBEE', fg: '#B71C1C' },
  { key: 'first_aid',  label: 'First Aid',   q: 'first aid bandage', Icon: HeartPulse,  bg: '#FFEBEE', fg: '#B71C1C' },
  { key: 'baby',       label: 'Baby Care',   q: 'baby',              Icon: Baby,        bg: '#F3E5F5', fg: '#4A148C' },
];

export default function EssentialsBar() {
  return (
    <div
      data-testid="essentials-bar"
      className="sticky top-14 md:top-16 z-40 bg-white border-b-2 border-ink/10 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-3 md:px-6 py-2">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[10px] uppercase tracking-[0.2em] font-black text-ink">
            Daily Essentials
          </span>
          <span className="text-[10px] text-ink/50">— tap what you need</span>
        </div>
        <div className="flex gap-2 overflow-x-auto scrollbar-none -mx-1 px-1 pb-1">
          {ESSENTIALS.map(({ key, label, q, Icon, bg, fg }) => (
            <Link
              key={key}
              data-testid={`essentials-tile-${key}`}
              to={`/search?q=${encodeURIComponent(q)}`}
              className="shrink-0 flex items-center gap-2 rounded-lg border-2 border-ink/10 hover:border-ink transition px-3 py-2 min-w-[110px]"
              style={{ backgroundColor: bg }}
            >
              <Icon className="w-4 h-4 shrink-0" style={{ color: fg }} />
              <span className="text-xs font-black uppercase tracking-wider" style={{ color: fg }}>
                {label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
